// assets/stock-counter.js
(function () {
  const SELECTOR = '.stock-counter';

  function parseData(el) {
    try {
      const json = el.querySelector('.stock-counter__data')?.textContent || '{}';
      return JSON.parse(json);
    } catch (e) {
      console.warn('[stock-counter] bad JSON', e);
      return {};
    }
  }

  function tone(el, val) {
    el.dataset.tone = val;
  }

  function formatMsg({ qty, available, tracked, policy }, threshold) {
  // Not tracked inventory
  if (!tracked) {
    if (available || policy === 'continue') {
      return { text: 'In stock — ships soon', tone: 'info' };
    }
    return { text: 'Sold out', tone: 'danger' };
  }

  // Tracked inventory
  if (!available) {
    if (policy === 'continue') {
      return { text: 'In stock — ships soon', tone: 'info' };
    }
    return { text: 'Sold out', tone: 'danger' };
  }

  // Show exact quantity
  if (typeof qty === 'number') {
    if (qty <= 0) {
      return { text: 'Sold out', tone: 'danger' };
    }

    if (qty <= 9) {
      return { text: `Only ${qty} left in stock!`, tone: qty <= 2 ? 'danger' : 'warning' };
    }

    // Default: show full qty
    // return { text: `${qty} in stock`, tone: 'success' };
  }

  // Fallback
  // return { text: 'In stock', tone: 'success' };
}


  function renderForVariant(counterEl, variantId) {
    if (!variantId) return;
    const map = parseData(counterEl);
    const rec = map[String(variantId)];
    const msgEl = counterEl.querySelector('.stock-counter__message');
    const threshold = parseInt(counterEl.dataset.threshold || '5', 10);

    if (!rec) {
      msgEl.textContent = 'Checking stock…';
      tone(msgEl, 'info');
      return;
    }

    const res = formatMsg(rec, threshold);
    msgEl.textContent = res.text;
    tone(msgEl, res.tone);
    counterEl.dataset.currentVariant = variantId;
  }

  function getVariantInputWithin(scope) {
    return scope.querySelector('input[name="id"]') || scope.querySelector('select[name="id"]');
  }

  function initOne(counterEl) {
    const initial = parseInt(counterEl.dataset.currentVariant || '0', 10);
    renderForVariant(counterEl, initial);

    // Try to scope to the nearest product form/section so we only react to the right variant control
    const container = counterEl.closest('section, form, .product, .product__info-wrapper') || document;

    // 1) Listen for changes on the variant id input/select inside the same container
    const variantInput = getVariantInputWithin(container);
    if (variantInput) {
      const updateFromInput = () => {
        const vid = parseInt(variantInput.value || '0', 10);
        if (vid) renderForVariant(counterEl, vid);
      };
      container.addEventListener('change', (e) => {
        if (e.target === variantInput || e.target.closest('[name="id"]')) updateFromInput();
      });
      // In some themes the input value changes programmatically; observe it too
      const mo = new MutationObserver(updateFromInput);
      mo.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    // 2) Dawn & many OS 2.0 themes dispatch a `variant:change` event with detail.variant
    document.addEventListener('variant:change', (e) => {
      const vid = e.detail?.variant?.id;
      if (!vid) return;

      // Heuristic: only update counters whose map contains this variant (avoids cross-product updates)
      const map = parseData(counterEl);
      if (String(vid) in map) renderForVariant(counterEl, vid);
    });

    // 3) Fallback: watch URL param ?variant=… (some themes update the URL only)
    window.addEventListener('popstate', () => {
      const url = new URL(location.href);
      const vid = parseInt(url.searchParams.get('variant') || '0', 10);
      if (vid) {
        const map = parseData(counterEl);
        if (String(vid) in map) renderForVariant(counterEl, vid);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in Theme Editor when section reloads
  document.addEventListener('shopify:section:load', initAll);
})();
